<template>
  <label :class="style.item">
    <input
      type="radio"
      class="sr-only"
      :name="groupName"
      :value="file.id"
      :checked="isActive"
      @change="$emit('selected', file)"
    />
    <span :class="style.icon">
      <Icon :icon="icon" />
    </span>
    <span :class="style.content">
      <h3>{{ file.name }}</h3>
    </span>
  </label>
</template>
<script setup lang="ts">
import { getIcon } from '@cutr/constants/files';
import type { CadFile } from '@cutr/constants/order';
import { computed } from 'vue';
import style from './list.module.css';

const props = defineProps<{
  file: CadFile;
  groupName: string;
  isActive?: boolean;
}>();

defineEmits<{
  (e: 'selected', file: CadFile): void;
}>();

const icon = computed(() => getIcon(props.file));
</script>
<style module>
.item {
  --drag-background: transparent;
  --position-sort-color: currentColor;
  --position-border-color: var(--neutral-400);
  --position-radius: 8px;

  display: grid;
  grid-template-columns: 2rem 1fr;
  border-radius: 8px;
  border: 1px solid var(--position-border-color);
  background-color: var(--drag-background);
  align-items: center;
  font-size: 0.875rem;
  line-height: 1rem;
  cursor: pointer;
}

.item:hover,
.item:has(input:checked) {
  --drag-background: var(--amber-600);
  --position-border-color: var(--amber-600);
  --position-sort-color: var(--neutral-50);
}

.item:has(input:focus-visible) {
  outline: 2px solid var(--purple-700);
  outline-offset: 2px;
}

.drag {
  display: grid;
  place-content: center;
  height: 100%;
  border-radius: var(--position-radius) 0 0 var(--position-radius);
  color: var(--position-sort-color);
  background-color: var(--drag-background);
  border-right: 1px solid var(--position-border-color);
}

.drag > span {
  --offsetRight: 0;
}

.content {
  --contentRadius: calc(var(--position-radius) - 1px);

  display: grid;
  align-items: center;
  gap: 0.5rem;
  margin: 1px;
  padding: calc(0.5rem - 2px) 0.5rem;
  background-color: var(--neutral-50);
  border-radius: 0 var(--contentRadius) var(--contentRadius) 0;
}

.content h3 {
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 400;
  margin: 0;
}
</style>
